import { ApplicationConfig } from '@angular/core';
import { HttpService } from './services/http/http.service';
import { RegistroIngresoService } from './services/registro-ingreso.service';
import { OrganizacionesUsuarioService } from './services/organizaciones-usuario.service';

export const coreConfig: ApplicationConfig = {
  providers: [
    HttpService,
    RegistroIngresoService,
    OrganizacionesUsuarioService,
  ],
};
